enum APIStatus {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Succeeded = 'SUCCEEDED',
  PartiallySucceeded = 'PARTIALLY_SUCCEEDED',
  Failed = 'FAILED',
}

export default APIStatus
